import Lines from "../../components/Lines";
import "./AdministrationDynamicPage.scss";

const AdministrationDynamicPage = ({ title, content, secondtitle, listitems }) => {
  return (
    <section className="administrationDynamicPageMainContainer">
      <header>
        <h2>{title}</h2>
        <div style={{ display: "flex" }}>
          <span className="linesParent">
            <Lines color="#0D553A" count={25} fontSize={2.3} spacing={0.5} />
          </span>
        </div>
      </header>
      <article>
        <p>{content}</p>
      </article>
      {title == "Examination Committee" &&(
              <article>
              <h3 >{secondtitle}</h3>
              <ul >
                <li>Prepare the academic calendar for internal and external examinations.</li>
                <li>Finalize examination timetables in coordination with departments.</li>
                <li>Coordinate with faculty to prepare question papers.</li>
                <li>Maintain the confidentiality and security of question papers.</li>
                <li>Standardize the format and quality of question papers.</li>
                <li> Appoint invigilators and examination staff. 
                  Ensure proper seating arrangements and availability of materials.</li>
                <li>Address any irregularities or malpractice during exams.
                  Notify students of examination schedules, rules, and procedures.</li>
                <li>Address student grievances related to exams.</li>
              </ul>
            </article>
      )}

    </section>
  );
};

export default AdministrationDynamicPage;
